import { Button, Carousel, Modal, Radio, Skeleton, Space } from 'antd';
import React, { useState, useEffect } from 'react';
import './CarModal.scss';
import { Link } from 'react-router-dom';
import { MdCheckCircle, MdMonetizationOn } from 'react-icons/md';
import Api from '../../network/ApiConfig';
import CarInfo from './CarInfo';
export default function CarModal({ open, setOpen, mainData, hideBtn }) {
  const [carSelect, setcarSelect] = useState(true);
  const [CarDetailesLoading, setCarDetailesLoading] = useState(false);
  const [CarModelDetails, setCarModelDetails] = useState(null);
  const mainSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    draggable: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const onChange = (e) => {
    console.log('radio checked', e.target.value);
    setcarSelect(e.target.value);
  };

  useEffect(() => {
    setcarSelect(true);
    setCarModelDetails(mainData);
    mainData && handelGetCarModelDetails();
  }, [mainData]);
  const handelGetCarModelDetails = () => {
    console.log(mainData, 'mainData in modalllllllll');
    setCarDetailesLoading(true);
    Api.get(`CarModels/GetCarModelDetails?CarModelId=${mainData?.Id}`).then(
      (res) => {
        setCarDetailesLoading(false);
        if (res?.status === 200) {
          console.log('sdfasdsdafdsf', res?.data);
          setCarModelDetails(res?.data?.model || null);
        }
        // setbrandList();
      },
      (err) => {
        setCarDetailesLoading(false);
        // console.log(err, "errrrrrrrrrrrrrrrrrrrrrrrrrrr")
      }
    );
  };

  return (
    <Modal
      title={mainData?.NameLT}
      open={open}
      width={'auto'}
      footer={null}
      onCancel={() => setOpen(false)}
      wrapClassName="modal-car"
      destroyOnClose
    >
      <div className="car-modal-wrapper">
        <div className="car-modal-top">
          <div className="car-modal-slider">
            {CarDetailesLoading ? (
              <Skeleton.Image active />
            ) : (
              <Carousel {...mainSettings}>
                <img src={CarModelDetails?.Image} alt="" />
                {CarModelDetails?.CarModelImages?.map((img) => (
                  <img src={img} alt="" />
                ))}
              </Carousel>
            )}
          </div>
          {!carSelect ? (
            <div className="car-select-list-holder">
              <h5 className="car-name">{mainData?.NameLT}</h5>
              <div className="car-select-list">
                <Radio.Group onChange={onChange} value={carSelect}>
                  <Space direction="vertical" size="large">
                    <Radio value={1}>
                      <div className="car-option-select">
                        <p>toyota fortuner 2023 automatic</p>
                        <div className="car-select-price">
                          {' '}
                          <MdMonetizationOn /> 433344 SAR
                        </div>
                      </div>
                    </Radio>
                    <Radio value={2}>
                      <div className="car-option-select">
                        <p>toyota fortuner 2023 manual</p>
                        <div className="car-select-price">
                          {' '}
                          <MdMonetizationOn /> 222 SAR
                        </div>
                      </div>
                    </Radio>
                    <Radio value={3}>
                      <div className="car-option-select">
                        <p>toyota fortuner 2013 manual</p>
                        <div className="car-select-price">
                          {' '}
                          <MdMonetizationOn /> 4444 SAR
                        </div>
                      </div>
                    </Radio>
                  </Space>
                </Radio.Group>
              </div>
            </div>
          ) : (
            <div className="car-modal-info">
              <CarInfo data={CarModelDetails} />
              <Link to={{ pathname: '/finance', state: { mainData } }}>
                {!hideBtn && (
                  <Button
                    type="primary"
                    size="large"
                    className="order-btn"
                    block
                  >
                    اطلب الان
                  </Button>
                )}
              </Link>
            </div>
          )}
        </div>
        <div className="car-modal-bottom">
          {CarModelDetails?.CarModelCharacteristics?.length ? (
            <>
              <div className="car-details-title" style={{ marginTop: 20 }}>
                <strong>معلومات اضافيه</strong>
              </div>
              <div className="car-details-holder car-additional-details-holder">
                {CarModelDetails?.CarModelCharacteristics?.map((x) => (
                  <div className="car-info-row">
                    <MdCheckCircle />
                    <label>{x?.CarCharacteristic?.NameLT}</label>
                  </div>
                ))}
              </div>
            </>
          ) : null}
        </div>
      </div>
    </Modal>
  );
}
